export const employeeListAccessFilter = (list: any[], value: number) => {
  return list.map(i => ({
    ...i,
    accesses: i.accesses.filter(
      a =>
        (a.oktmo !== value ||
          a.type_right_read_only ||
          a.type_right_read_write) &&
        a.type_right !== 0
    ),
  }));
};
